import {
  As,
  HStack,
  Icon,
  Link,
  Stack,
  StackProps,
  Text,
} from '@chakra-ui/react';
import { FC } from 'react';
import { Link as RouteLink, LinkProps, useLocation } from 'react-router-dom';
import { Gear, Lightbulb, Money, Team, Ticket } from '../../../assets';
import { getDataTracking } from '../../../utils';
import { useTeamsAllowed } from '../../../hooks';

export const SideNavItem: FC<{
  icon: As;
  label: string;
  to?: LinkProps['to'];
  onClick?: () => void;
}> = ({ icon, label, to = '', onClick }) => {
  const location = useLocation();
  const cleanString = location?.pathname.replace('/', '');
  const linkActive = label.toLowerCase().includes(cleanString);
  return (
    <Link
      {...getDataTracking(`sidebar${label}Link`)}
      as={RouteLink}
      to={`/${to}`}
      onClick={onClick}
      textDecoration="none"
      _hover={{
        textDecoration: 'none',
      }}
    >
      <HStack
        spacing={4}
        color={
          linkActive ? 'brand.monochromatic.900' : 'brand.monochromatic.700'
        }
        fontWeight={linkActive ? 'extrabold' : 'normal'}
      >
        <Icon as={icon} boxSize="24px" />
        <Text fontSize="md">{label}</Text>
      </HStack>
    </Link>
  );
};

export type UserMenuProps = StackProps;

export const UserMenu: FC<UserMenuProps> = ({ ...rest }) => {
  const teamsExist = useTeamsAllowed();

  return (
    <Stack spacing={6} {...rest}>
      <SideNavItem icon={Gear} label="Dashboard" to="dashboard" />
      <SideNavItem icon={Money} label="Donations" to="donations" />
      {teamsExist && <SideNavItem icon={Team} label="Team" to="team" />}
      <SideNavItem icon={Ticket} label="Event Registration" to="registration" />
      <SideNavItem icon={Lightbulb} label="Resources & Tips" to="resources" />
    </Stack>
  );
};
